import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';
const wizardName = 'Customer association';
const wizardAction = 'customerAssociation';

const CustomerAssociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const {
        item,
        errorMessage,
        errors,
        saving,
        doAction,
    } = useDataProvider(dataProviderName, params.multipart);

    const modelName = existingModules.modelName;

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "available_customer": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "associated": {
                                "type": "legalEntityList",
                                "dataProviderName": "companies/legalentity",
                                "defaultSelectedValues": [],
                                "enableSelection": true,
                                "disableMultipleRowSelection": true,
                                "hideTableToolbar": true,
                                "relation": {
                                    "columnsNeeded": [
                                        "name",
                                        "vat",
                                        "type"
                                    ]
                                },
                                "filters": {
                                    "items": [
                                        {
                                            "field": "type",
                                            "operator": "in",
                                            "value": ["customer"]
                                        }
                                    ]
                                },
                                "className": "col-12",
                                "required": true
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    };

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data })
            .then((data) => params.handleClose(params.uid, data.item.data))
            .catch(() => console.error('catch handleSave'));
    };

    const carIdentifier = item?.data?.plate
        ? item.data.plate
        : `${item?.data?.setup?.make ?? ''} ${item?.data?.setup?.model ?? ''}`.trim();

    return (
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ "id": item?.data?._id }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Assign {{carIdentifier}} to a customer', { carIdentifier })}
                />
            }
            {...params}
        />
    );
};

export default CustomerAssociation;
